// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"687":"c33547a0","974":"08e40c21"}[chunkId] + ".chunk.css";
};